import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { VolunteerSignupMentor } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {
	const columns: GridColumn<VolunteerSignupMentor, unknown>[] = [
		buildColumn(util, 'Id', row => row.assignedToStaffId, { header: 'assignedToStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.assignedToStaffId), { header: 'Assigned Staff', width: 90 }),
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'lastContactStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 90 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 80 }),
		buildColumn(util, 'Id', row => row.volunteerSignupMentorId, { header: 'VolunteerSignupMentorId' }),
		buildColumn(util, 'FullName', row => row.person.fullName, { header: 'Name' }),
		buildColumn(util, 'Number', row => row.trimesterId, { header: 'TrimesterId', hidden: true }),
		buildColumn(util, 'Text', row => app.getTrimesterNameById(row.trimesterId), { header: 'Trimester', group: 'asc' }),
		buildColumn(util, 'Text', row => row.volunteerSignupMentorStatus, { header: 'Status' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Signed-up Date' }),
		buildColumn(util, 'Text', row => row.selectedLanguage, { header: 'Selected Languages' }),
		buildColumn(util, 'Number', row => row.numMeetings, { header: 'Count of Meetings' }),
	];

	return columns;

}
